import hoist from 'hoist-non-react-statics';
import React from 'react';
import getDisplayName from '../getDisplayName';

/**
 * Appends an "isScreenshotTest" boolean to the rendered component to
 * allow for customization of output in a screenshot test scenario.
 *
 * This is useful for highly dynamic components like GoogleMap that do
 * most of their rendering work client-side, but should display _something_
 * for a screenshot test.
 */
export default function withScreenshot(WrappedComponent) {
    class WithScreenshot extends React.Component {
        static displayName = `WithScreenshot(${getDisplayName(WrappedComponent)})`;
        static WrappedComponent = WrappedComponent;

        render() {
            return React.createElement(WrappedComponent, {
                ...this.props,
                isScreenshotTest: !!global.screenshot,
            });
        }
    }

    hoist(WithScreenshot, WrappedComponent);

    return WithScreenshot;
}
